export const LINK_PREVIEW_PREFIX = 'LP';

export const NO_LINK_PREVIEW_ANCHOR_ID = LINK_PREVIEW_PREFIX + 'NoLP';
export const LINK_PREVIEW_ANCHOR_ID = LINK_PREVIEW_PREFIX + 'lnk';

export const LINK_PREVIEW_BORDER_ID_BASE = LINK_PREVIEW_PREFIX + 'Border';
export const LINK_PREVIEW_BORDER_WEBPAGE_TYPE = 'GT';
export const LINK_PREVIEW_BORDER_VIDEO_TYPE = 'BVT';

export const LINK_PREVIEW_CONTAINER_ID = LINK_PREVIEW_PREFIX + 'Container';
export const LINK_PREVIEW_IMAGE_CONTAINER_ID = LINK_PREVIEW_PREFIX + 'ImageContainer';
export const LINK_PREVIEW_IMAGE_ANCHOR_ID = LINK_PREVIEW_PREFIX + 'ImageAnchor';
export const LINK_PREVIEW_IMAGE_THUMBNAIL_ID = LINK_PREVIEW_PREFIX + 'ThumbnailImageId';
export const LINK_PREVIEW_TITLE_ID = LINK_PREVIEW_PREFIX + 'Title';
export const LINK_PREVIEW_URL_ANCHOR_ID = LINK_PREVIEW_PREFIX + 'UrlAnchor';
export const LINK_PREVIEW_METADATA_ID = LINK_PREVIEW_PREFIX + 'Metadata';
export const LINK_PREVIEW_DESCRIPTION_ID = LINK_PREVIEW_PREFIX + 'Description';

export const LINK_PREVIEW_CLOSE_BUTTON_ID = LINK_PREVIEW_PREFIX + 'CloseButton';
export const LINK_PREVIEW_CLOSE_BUTTON_CONTAINER_ID = LINK_PREVIEW_PREFIX + 'CloseButtonContainer';

export const BING_RTP_LINK_PREVIEW_TYPE = 'BingRTPLinkPreview:#Exchange';
export const BING_VIDEO_LINK_PREVIEW_TYPE = 'BingVideoLinkPreview:#Exchange';

export const COMPOSE_ONLY_CONTENT_START = 'owa-remove-on-send-start';
export const COMPOSE_ONLY_CONTENT_END = 'owa-remove-on-send-end';

export const ENTER_CHARCODE = 13;

export function createLinkPreviewIdNumber(): string {
    // Want to make sure the number is always 6 digits and the first digit is never 0
    return Math.floor(100000 + Math.random() * 900000).toString();
}

function parseLinkPreviewIdNumber(source: string) {
    return source && source.slice(-6);
}

export function createLinkPreviewId(sourceId: string, prefix: string): string {
    return prefix + parseLinkPreviewIdNumber(sourceId);
}

// Check if the element's id begins with the desired prefix
export function elementHasLinkPreviewPrefix(element: HTMLElement, desiredPrefix: string) {
    return element && element.id && element.id.indexOf(desiredPrefix) == 0;
}
